import React from "react";

export default function Chat() {
  return (
    <svg
      width="48"
      height="46"
      viewBox="0 0 48 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5 21.0088H32.0559"
        stroke="#B9BABF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M24.5 24.3145H29.6947"
        stroke="#B9BABF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M32.9993 14.244C31.61 13.4404 29.9971 12.9805 28.2769 12.9805C23.0606 12.9805 18.832 17.2091 18.832 22.4253C18.832 23.9362 19.1868 25.3641 19.8176 26.6306C19.9852 26.9671 20.041 27.3518 19.9438 27.715L19.3813 29.8175C19.1371 30.7301 19.972 31.5651 20.8847 31.3209L22.9872 30.7584C23.3504 30.6612 23.735 30.717 24.0716 30.8845C25.338 31.5154 26.766 31.8701 28.2769 31.8701C33.493 31.8701 37.7217 27.6415 37.7217 22.4253C37.7217 20.705 37.2617 19.0921 36.4582 17.7029"
        stroke="#B9BABF"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}
